import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { PodOrderStatusSummaryModel } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import {
    ApiResultModel,
    getPodSubscribers,
} from "@WhiteCap/Store/Service/OsnSubscriptionsServices/PodSubscribersService";

export interface SubscriptionsDashboardApiParameter extends ApiParameter {
    customerId?: string;
    onError?: (message: string) => void;
    onSuccess?: (data: PodOrderStatusSummaryModel) => void;
}
type HandlerType = CustomApiHandler<SubscriptionsDashboardApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/BeginPodSubscribersDataLoad",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getPodSubscribers(props.apiParameter.customerId);
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter.onSuccess) {
            const data = {
                properties: result.result.properties,
                subscribedEmails: result.result.subscribedEmails,
                count: result.result.podOrderStatusSummary?.count,
                frequency: result.result.podOrderStatusSummary?.frequency,
            };
            props.apiParameter.onSuccess(data);
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/PodSubscribersDataLoadError",
        });
        return false;
    }
};

export const DispatchCompletePodSubscribersDataLoad: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/CompletePodSubscribersDataLoad",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompletePodSubscribersDataLoad];

const loadPodSubscribers = createHandlerChainRunner(chain, "LoadPodSubscribers");
export default loadPodSubscribers;
